import { useContext } from "react";
import { LayerContext } from "../LayerContext";
import { OsmRoadsInfo } from "../../../../types/LayerAdmin/OsmRoadsInfo";
import SortableTable from "../../../Table/SortableTable";
import {
  TableColumn,
  TableDataType,
} from "../../../../types/Table/TableColumns";

const GeoFabrikReport = () => {
  const value = useContext(LayerContext);
  const { layerInfo } = value!;
  const osmInfo = layerInfo as OsmRoadsInfo;

  const cols = [
    { displayName: "Source", field: "id", sortable: true },
    { displayName: "Url", field: "url", dataType: TableDataType.LINK },
  ] as TableColumn[];

  return (
    <SortableTable data={osmInfo.missingGeofabrikSources} columns={cols} />
  );
};

export default GeoFabrikReport;
